<template>
  <div>
    <h1>Bidder details</h1>
    <form @submit.prevent="signIn(user)">
      <label>Name</label>
      <input type="text" v-model="user.name" />
      <label>Phone</label>
      <input type="text" v-model="user.phone" />
      <input type="submit" value="Done" />
      <Error :message="error" />
    </form>
  </div>
</template>

<script>
import Error from "@/components/Error";

export default {
  name: "Auction",
  components: {
    Error,
  },
  data() {
    return {
      user: {
        name: this.$store.getters.currentUser.name,
        phone: this.$store.getters.currentUser.phone,
      },
      error: null,
    };
  },
  methods: {
    signIn(user) {
      this.error = null;
      if (user.phone.length !== 10) {
        this.error =
          "Your mobile number needs to be 10-digits long and start with 04.";
      } else {
        this.$store.commit("setCurrentUser", user);
        this.$router.push({ path: "/" });
      }
    },
  },
};
</script>